import React, { Component } from "react";
import { Progress, Button, message, Form, Input } from 'antd';
import { toSave, getDownloadSpace } from "@/fetch/api/personal";
import QiniuUpload from '@/components/QiniuUpload';
import './index.less';
export default class FileContainer extends Component {
  state = {
    percent: 0,
    fileName: '',
    file: '',
    // 上传文件
    uploader: '',
    // 上传实例
    space: '' // 储存空间提示

  };

  componentDidMount() {
    this.initSpace();
    let fileImageValues = this.props.data.fileImageValues || this.props.data.colValue;

    if (fileImageValues && fileImageValues[0].fileName) {
      this.setState({
        fileName: fileImageValues[0].fileName
      });
      this.props.form.setFieldsValue({
        [JSON.stringify(this.props.data.fieldId)]: fileImageValues[0].resourceListId || fileImageValues[0].uploadResourceId || '',
        [`file${this.props.data.fieldId}`]: fileImageValues[0].fileName || ''
      });
    }
  }

  initSpace = () => {
    // 储存空间
    getDownloadSpace({
      "type": "shangchuan"
    }).then(res => {
      if (res.code === '1') {
        this.setState({
          space: ''
        });
        return;
      }

      this.setState({
        space: res.message
      });
    }).catch(err => Promise.reject(err));
  };
  handleFilesAdded = async (file, uploader) => {
    // 文件上传队列判断
    const file100m = 5 * 1024 * 1024;

    if (this.state.space && this.props.deductionSpaceFlag) {
      message.destroy();
      message.error(this.state.space);
      uploader.removeFile(file.id);
      return false;
    }

    if (file.size > file100m) {
      message.destroy();
      message.warning('上传的文件过大，请控制在5M以下重新上传');
      uploader.removeFile(file.id);
      return false;
    }

    this.setState({
      file,
      uploader,
      fileName: file.name
    });
  };
  handlePercent = (id, percent) => {
    // 获取文件进度
    this.setState({
      percent
    });
  };
  handleFileUploaded = (file, res, uploader, id) => {
    const type = file.name.substring(file.name.lastIndexOf(".") + 1);
    const imgs = ['JPG', 'jpg', 'png', 'gif'];
    const docs = ['doc', 'xls', 'ppt', 'docx', 'xlsx', 'pptx', 'txt'];
    let fileCategory = 'pdf';

    if (imgs.includes(type)) {
      fileCategory = 'image';
    }

    if (docs.includes(type)) {
      fileCategory = 'docs';
    }

    toSave({
      fileName: file.name,
      fileType: type,
      sourcePath: res.key,
      sourceSize: file.size,
      fileCategory,
      uploadType: 0,
      deductionSpaceFlag: this.props.deductionSpaceFlag || 0
    }).then(res => {
      if (res.code === '1') {
        this.setState({
          fileName: file.name
        });
        this.props.form.setFieldsValue({
          [JSON.stringify(this.props.data.fieldId)]: res.data,
          [`file${this.props.data.fieldId}`]: file.name
        });
        return;
      }

      this.setState({
        fileName: ''
      });
      message.destroy();
      message.warning(res.message);
    }).catch(err => Promise.reject(err));
  };
  handleDel = () => {
    // 删除处理
    const {
      uploader,
      file
    } = this.state;

    if (uploader) {
      uploader.removeFile(file.id);
    }

    this.setState({
      fileName: '',
      file: '',
      uploader: ''
    });
    this.props.form.setFieldsValue({
      [JSON.stringify(this.props.data.fieldId)]: '',
      [`file${this.props.data.fieldId}`]: ''
    });
  };

  render() {
    const {
      data
    } = this.props;
    const {
      percent,
      fileName
    } = this.state;
    const {
      getFieldDecorator,
      getFieldError
    } = this.props.form;
    let errArr = getFieldError(JSON.stringify(data.fieldId));
    return getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || "";

          if (data.required && val === "") {
            callback('必填项，请输入相关信息');
            return;
          }

          callback();
        }
      }],
      initialValue: data.value || ''
    })(<div data-inspector-line="152" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" className="detail-sel-file detail-sel-wrap">
          <QiniuUpload data-inspector-line="153" data-inspector-column="10" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" id={`applyFile${data.fieldId}`} extensions="doc,pdf,docx,xlsx,ppt,pptx,pdf,rar,zip" children={<Button data-inspector-line="156" data-inspector-column="22" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" disabled={data.frontUpdateFlag === 1}><i data-inspector-line="156" data-inspector-column="68" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" className="iconfont iconshangchuan" />{fileName ? '重新上传' : '上传附件'}</Button>} handleFilesAdded={this.handleFilesAdded} handlePercent={this.handlePercent} handleFileUploaded={this.handleFileUploaded} />
          {fileName && percent && <Progress data-inspector-line="161" data-inspector-column="34" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" percent={percent} /> || null}
          {fileName && <p data-inspector-line="162" data-inspector-column="23" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" className="detail-file-name">
            {getFieldDecorator(`file${data.fieldId}`, {
          initialValue: fileName || ''
        })(<span data-inspector-line="166" data-inspector-column="14" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx">{fileName}</span>)}
            <i data-inspector-line="168" data-inspector-column="12" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" className="iconfont iconguanbi1" onClick={this.handleDel} />
          </p> || null}
          {errArr && <p data-inspector-line="170" data-inspector-column="21" data-inspector-relative-path="src\\components\\CreateFormItem\\FileContainer\\index.jsx" className="file-err-text">{errArr[0]}</p> || null}
        </div>);
  }

}